var React = require('react');

function BlobMiddle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"blob__body","d":"M105.043 246.657C87.2405 232.715 77.1338 229.278 76.529 207.517L73.7357 104.671C72.6492 65.5833 104.002 34.8709 143.764 36.0731C183.526 37.2753 216.64 69.9369 217.726 109.025L218.007 121.47L222.873 249.546L166.265 240.452C144.921 245.024 122.846 260.599 105.043 246.657Z","fill":"#FFB6AB","key":0}),React.createElement("path",{"className":"blob__face","d":"M125.413 62.6623C128.746 69.987 137.234 68.9011 139.775 63.0579M147.029 62.8369C150.362 70.1616 158.85 69.0758 161.391 63.2326M111.251 68.8341C126.143 86.6195 165.657 85.5081 176.648 67.7673","stroke":"#FF553C","strokeWidth":"3.91287","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BlobMiddle.defaultProps = {"width":"349","height":"340","viewBox":"0 0 349 340","fill":"none"};

module.exports = BlobMiddle;

BlobMiddle.default = BlobMiddle;
